var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      staticClass: "pl-2 pr-4 relative cursor-pointer overflow-visible",
      scopedSlots: _vm._u([
        {
          key: "toggle",
          fn: function () {
            return [
              _vm.notificationCount > 0
                ? _c(
                    "samc-icon-indicator",
                    {
                      attrs: {
                        indicator: "!",
                        visible: "",
                        position: "top-right",
                      },
                    },
                    [_c("icon-notifications")],
                    1
                  )
                : _c("i", {
                    staticClass:
                      "mdi mdi-bell-outline text-2xl text-secondary-900",
                  }),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.showMenu,
        callback: function ($$v) {
          _vm.showMenu = $$v
        },
        expression: "showMenu",
      },
    },
    [
      _vm._v(" "),
      _c("nav", { ref: "notificationMenu", staticClass: "notification-menu" }, [
        _c(
          "div",
          { staticClass: "item w-116" },
          [
            _c(
              "tabs",
              {
                scopedSlots: _vm._u([
                  {
                    key: "badge",
                    fn: function ({ index, active }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass:
                              "rounded-full px-[6px] ml-1 font-semibold",
                            class: active
                              ? "bg-white text-secondary-900"
                              : _vm.getTabBadgeClasses(index),
                            staticStyle: { "font-size": "14px !important" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getTabBadgeCount(index)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.tabIndex,
                  callback: function ($$v) {
                    _vm.tabIndex = $$v
                  },
                  expression: "tabIndex",
                },
              },
              [
                _vm._v(" "),
                _vm._l(_vm.tabNames, function (tabName, i) {
                  return _c(
                    "tab",
                    {
                      key: tabName,
                      staticClass: "flex flex-row flex-grow",
                      attrs: {
                        title: tabName,
                        disabled: _vm.isTabDisabled(tabName),
                      },
                    },
                    [
                      tabName === "Approvals"
                        ? _c(
                            "div",
                            { staticClass: "block h-52 w-full" },
                            [
                              _vm.showTaskNotificationGrids &&
                              _vm.activeTabName === "Approvals"
                                ? _c("tm-task-grid", {
                                    key: "notification-approvals-grid",
                                    ref: "approvalsTaskGrid",
                                    refInFor: true,
                                    staticClass: "flex-grow h-full w-full",
                                    attrs: {
                                      token: _vm.verificationToken,
                                      "api-root": _vm.taskManagementUrl,
                                      jwt: _vm.jwtToken ?? undefined,
                                      "hide-toolbar": "",
                                      "hide-floating-filters": "",
                                      "fit-visible-columns-to-width": "",
                                      "max-rows":
                                        _vm.approvalNotificationMaxRows,
                                      "client-side-sort": "",
                                      "hide-selection-column": true,
                                      "hide-edit-column":
                                        _vm.hideTaskEditColumn,
                                      "hide-history-column": true,
                                      "hide-task-level-reference-column": true,
                                      "hide-assigned-to-column": true,
                                      "hide-watchers-column": true,
                                      "hide-status-column": true,
                                      "hide-approvers-column": true,
                                      "hide-email-flag-column": true,
                                      "hide-approval-required-column": true,
                                      "hide-task-email-sent-date-column": true,
                                      "hide-email-sent-flag-column": true,
                                      "hide-modified-date-column": true,
                                      "hide-modified-by-column": true,
                                      "hide-created-date-column": true,
                                      "hide-created-by-column": true,
                                      "hide-total-row-count": true,
                                    },
                                    domProps: {
                                      filters: _vm.approvalsNotificationFilters,
                                    },
                                    on: { taskSaved: _vm.onApprovalTaskSaved },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : tabName === "EMails"
                        ? _c(
                            "div",
                            { staticClass: "block h-52 w-full" },
                            [
                              _vm.showTaskNotificationGrids &&
                              _vm.activeTabName === "EMails"
                                ? _c("tm-task-grid", {
                                    key: "notification-emails-grid",
                                    ref: "emailsTaskGrid",
                                    refInFor: true,
                                    staticClass: "flex-grow h-full w-full",
                                    attrs: {
                                      token: _vm.verificationToken,
                                      "api-root": _vm.taskManagementUrl,
                                      jwt: _vm.jwtToken ?? undefined,
                                      "hide-toolbar": "",
                                      "hide-floating-filters": "",
                                      "fit-visible-columns-to-width": "",
                                      "max-rows":
                                        _vm.approvalNotificationMaxRows,
                                      "client-side-sort": "",
                                      "hide-selection-column": true,
                                      "hide-edit-column":
                                        _vm.hideTaskEditColumn,
                                      "hide-history-column": true,
                                      "hide-task-level-reference-column": true,
                                      "hide-assigned-to-column": true,
                                      "hide-watchers-column": true,
                                      "hide-status-column": true,
                                      "hide-approvers-column": true,
                                      "hide-email-flag-column": true,
                                      "hide-approval-required-column": true,
                                      "hide-task-email-sent-date-column": true,
                                      "hide-email-sent-flag-column": true,
                                      "hide-modified-date-column": true,
                                      "hide-modified-by-column": true,
                                      "hide-created-date-column": true,
                                      "hide-created-by-column": true,
                                      "hide-total-row-count": true,
                                    },
                                    domProps: {
                                      filters: _vm.emailsNotificationFilters,
                                    },
                                    on: { taskSaved: _vm.onEmailTaskSaved },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : tabName === "Autosaves"
                        ? _c(
                            "div",
                            { staticClass: "block h-52 w-full" },
                            [
                              _c(
                                "grid",
                                {
                                  ref: "autosaveGrid",
                                  refInFor: true,
                                  staticClass: "flex-grow h-full w-full",
                                  attrs: {
                                    "data-source":
                                      _vm.currentTabs["Autosaves"].dataSource,
                                    "floating-filter": false,
                                    "include-column-filter": false,
                                    "auto-size-columns": false,
                                    "suppress-horizontal-scroll": "",
                                    "suppress-totals": "",
                                    "suppress-status-bar": "",
                                    "suppress-row-virtualisation": "",
                                  },
                                  on: {
                                    "row-double-clicked": _vm.onRowDoubleClick,
                                  },
                                },
                                [
                                  _c("grid-column", {
                                    attrs: {
                                      field: "packageName",
                                      "header-name": "Package",
                                      width: 140,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("grid-column", {
                                    attrs: {
                                      field: "mappingName",
                                      "header-name": "Map",
                                      width: 140,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("grid-column", {
                                    attrs: {
                                      field: "mappingGroupName",
                                      "header-name": "Group",
                                      width: 80,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("grid-column", {
                                    attrs: {
                                      field: "fileName",
                                      "header-name": "File",
                                      width: 140,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("grid-column", {
                                    attrs: {
                                      field: "step",
                                      "header-name": "Step",
                                      flex: "1",
                                      "value-getter": _vm.customStepValueGetter,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("grid-column", {
                                    attrs: {
                                      field: "commands",
                                      "header-name": "",
                                      "min-width": 40,
                                      "max-width": 40,
                                      "suppress-header-menu-button": true,
                                      sortable: false,
                                      resizable: "false",
                                      "cell-renderer": "iconButtonRenderer",
                                      filter: "false",
                                      "cell-renderer-params": {
                                        onClick: _vm.onContinueClick,
                                        icon: "icon-checkmark",
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("grid-column", {
                                    attrs: {
                                      field: "commands",
                                      "header-name": "",
                                      "min-width": 40,
                                      "max-width": 40,
                                      "suppress-header-menu-button": true,
                                      sortable: false,
                                      resizable: "false",
                                      "cell-renderer": "iconButtonRenderer",
                                      filter: "false",
                                      "cell-renderer-params": {
                                        onClick: _vm.onRemoveClick,
                                        icon: "icon-trash",
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex w-full float-right z-10 relative" },
                  [
                    _c("div", { staticClass: "flex-grow" }),
                    _vm._v(" "),
                    _vm.activeTabName === "Autosaves"
                      ? _c(
                          "btn",
                          {
                            staticClass: "m-1 bg-red vertical",
                            on: {
                              click: function ($event) {
                                return _vm.clearAll()
                              },
                            },
                          },
                          [_vm._v("Remove All")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "btn",
                      {
                        staticClass: "m-1 vertical",
                        on: {
                          click: function ($event) {
                            return _vm.gotoResults()
                          },
                        },
                      },
                      [_vm._v("See All Results")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }